var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sr-marketing-cloud-logo brand-blue"},[_vm._m(0),_c('MarketingCloudImage')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-heading"},[_c('span',{staticClass:"logo-title brand-red"},[_vm._v(" Marketing Cloud ")]),_c('span',{staticClass:"logo-sub-title"},[_vm._v("All your marketing needs in one cloud.")])])
}]

export { render, staticRenderFns }